import React from "react";
import "./styles.css";
import { CollapseCardItem } from "../CollapseCard";
import icons from "../../constants/icons";
import NewProfile from "../BusinessProfile/NewProfile";
import { UploadFiles } from "../MerchantKYCFiles";
import { ListContacts } from "../Contacts";
import { ListBusinessAddress } from "../Addresses";
import ListBoardMembers from "../BoardMember/ListBoardMembers";
import ListDirectors from "../Directors/ListDirectors";
import { connect } from "react-redux";
import FileUpload from "../MerchantKYCFiles/FileUpload";
import AlertMessage from "./AlertMessage";

class CaptureInfoForm extends React.Component {
  state = {
    active: 1,
    items: [],
  };

  componentDidMount = async () => {
    this.handleProfileUnits();
  };

  handleProfileUnits() {
    const { profileUnits } = this.props;
    let items = [];

    profileUnits.forEach((profileEl) => {
      if (profileEl.unit === "BUSINESS_PROFILE") {
        items.unshift({
          id: "businessProfile",
          title: "Business Profile",
          icon: icons.business_profile,
          isCollapsed: true,
          provided: profileEl.provided,
          description:
            "This profile ensures secure transactions and compliance with financial regulations.",
          data: (
            <>
              <NewProfile
                toggleSubmitButton
                footerClassName="no-border-top"
                handleCollapsePreviousAndShowNext={() =>
                  this.handleCollapsePreviousAndShowNext(0, 1)
                }
                approved={profileEl.approved}
                profileUpdated={this.profileUpdated.bind(this)}
              />
              <FileUpload profileUnitId={profileEl.profileUnitId} />
            </>
          ),
        });
      }

      if (profileEl.unit === "ADDRESS") {
        items.push({
          title: "Address",
          description: "Provide your business address",
          icon: icons.address,
          isCollapsed: true,
          provided: profileEl.provided,
          data: (
            <div className="card-body">
              <ListBusinessAddress showAdd search />
              <FileUpload
                profileUnitId={profileEl.profileUnitId}
                isMultiple
                profileUpdated={this.profileUpdated.bind(this)}
              />
            </div>
          ),
        });
      }

      if (profileEl.unit === "CONTACT") {
        items.push({
          title: "Contact Details",
          icon: icons.user,
          isCollapsed: true,
          provided: profileEl.provided,
          description:
            "Please provide contact details for reaching your company.",
          data: (
            <div className="card-body">
              <ListContacts showAdd />
              <FileUpload
                profileUnitId={profileEl.profileUnitId}
                isMultiple
                profileUpdated={this.profileUpdated.bind(this)}
              />
            </div>
          ),
        });
      }
      if (profileEl.unit === "BOARD_MEMBER") {
        items.push({
          title: "Board Members",
          icon: icons.users,
          isCollapsed: true,
          provided: profileEl.provided,
          description: "Add board members ",
          data: (
            <>
              <div className="card-body mb-3">
                <ListBoardMembers
                  showAdd
                  profileUnitId={profileEl.profileUnitId}
                />
              </div>
              <FileUpload
                profileUnitId={profileEl.profileUnitId}
                isMultiple
                profileUpdated={this.profileUpdated.bind(this)}
              />
            </>
          ),
        });
      }
      if (profileEl.unit === "COMPANY_DIRECTOR") {
        items.push({
          title: "Directors Details",
          icon: icons.directors,
          isCollapsed: true,
          provided: profileEl.provided,
          description: "Add company directors.",
          data: (
            <>
              <div className="card-body">
                <ListDirectors showAdd />
              </div>
              <FileUpload
                profileUnitId={profileEl.profileUnitId}
                isMultiple
                profileUpdated={this.profileUpdated.bind(this)}
              />
            </>
          ),
        });
      }

      if (profileEl.unit === "DOCUMENTS") {
        items.push({
          title: "Documents Upload",
          icon: icons.fileUpload,
          isCollapsed: true,
          provided: profileEl.provided,
          description: "Uploading all documents is mandatory.",
          data: (
            <FileUpload
              isGeneralDocumentUpload
              profileUnitId={profileEl.profileUnitId}
              profileUpdated={this.profileUpdated.bind(this)}
            />
          ),
        });
      }
    });

    // items[0].isCollapsed = true;
    this.setState({ items });
  }

  profileUpdated(needToReload) {
    if (needToReload) {
      window.location.reload();

      return;
    }

    this.setState({
      isCheckingProfileUnitsProgress: true,
    });
  }

  handleCollapse(index) {
    let { items } = this.state;
    items.map((el, elIndex) => {
      if (elIndex === index) {
        el.isCollapsed = !el.isCollapsed;
      } else {
        // el.isCollapsed = false;
      }
      return el;
    });

    this.setState({ items });
  }

  handleCollapsePreviousAndShowNext(prevIndex, nextIndex) {
    let { items } = this.state;

    console.log("items length *****", items.length);
    console.log("nextIndex *****", nextIndex);

    if (items.length > nextIndex) {
      // items[prevIndex].isCollapsed = false;
      items[nextIndex].isCollapsed = true;
    }

    this.setState({ items });
  }

  render() {
    return (
      <>
        <div className="onboarding-info-form-container">
          <center style={{ paddingBottom: "2.5rem" }}>
            <h2 className="text-bold">Complete the KYC Process</h2>
            <p>
              All fields with <span className="text-danger">(*)</span> are
              required
            </p>

            <small className="text-primary text-bold">Step 2 / 2</small>
          </center>
          <div className="row" id="businessProfile">
            <div className="col-xs-12 col-md-8 mx-auto">
              <div>
                {this.state.items.map((el, i) => {
                  let isCollapsed = el.isCollapsed;
                  return (
                    <div className="card mb-3">
                      <CollapseCardItem
                        key={i}
                        icon={el.icon}
                        title={el.title}
                        description={el.description}
                        isCollapsed={isCollapsed}
                        handleCollapse={() => this.handleCollapse(i)}
                        data={el.data}
                        provided={el.provided}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        {/* only run once  */}
        <AlertMessage />
        {/* will check every time client has provided information */}
        {this.state.isCheckingProfileUnitsProgress && <AlertMessage />}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { profileUnits } = state.ProfileUnits;
  return {
    profileUnits,
  };
};
export default connect(mapStateToProps)(CaptureInfoForm);
